import { withProps } from 'recompose';
import wizard from './wizardData';
import FormStep from '../../FormStep';

const Form = withProps(({ needFunding = false }) => ({
    wizard: wizard(needFunding),
}))(FormStep);

export default Form;
